import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import themesData from "../data/themes.json";
import AdSlot from "../components/AdSlot";
import { Button } from "../components/ui/button";
import SEO from "../components/SEO";
import { ChevronsRight } from "lucide-react";

const ThemePreview: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
useEffect(() => {
  const footer = document.querySelector("footer");
  const header = document.querySelector("header");
  if (footer) footer.style.display = "none";
if (header) header.style.display = "none";
  return () => {
    if (footer) footer.style.display = "";
    if (header) header.style.display = "";
  };
}, []);

  const theme = themesData.find((t: any) => t.slug === slug);
  if (!theme) return null;

  return (
    <div className="relative min-h-screen bg-gray-100">
        <SEO
  title={`Live Preview – ${theme.title}`}
  noIndex
/>


      {/* 🔙 Top bar */}
      <div className="sticky top-0 z-40 shadow bg-white border-b px-4 py-3 flex items-center justify-between">
        <h1 className="text-sm font-semibold truncate">
          Live Preview — {theme.title}
        </h1>

        <Button
          size="sm"
          onClick={() => navigate(`/theme/${theme.slug}`)}
        >
          Back to Details
        </Button>
      </div>

      {/* 🌐 IFRAME PREVIEW */}
      <div className="relative w-full h-[calc(100vh-56px)] pb-[120px]">
        <iframe
          src={theme.demoUrl}
          title={theme.title}
          className="w-full h-full border-none"
          loading="lazy"
        />
      </div>

      {/* 🟢 FLOATING BUY BUTTON */}
      <a
        href={`/theme/${theme.slug}#premium`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-1 top-[70%] z-50"
      >
        <Button size="sm" className="animate-bounce w-full text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 shadow-lg shadow-blue-500/50 font-medium rounded-base text-sm px-4 py-2.5 text-center leading-5">
          Buy Now <ChevronsRight/>
        </Button>
      </a>

      {/* 📌 FIXED BOTTOM AD */}
      <div className="fixed bottom-0 left-0 w-full z-40 bg-white border-t max-h-[107px] min-h-[107px]">
        <div className="max-w-7xl mx-auto py-2">
          <AdSlot slot="previewBottom" />
        </div>
      </div>
    </div>
  );
};

export default ThemePreview;
